export default "__VITE_ASSET__8a2dc803__"